import { $win } from '../utils/globals';

/**
 * Mobile menu button and links
 *
 * @return {void}
 */

$('.nav-trigger').on('click', function(e){
    e.preventDefault();

    $(this).toggleClass('nav-trigger--active');
    $('.nav').slideToggle().find('.isOpen').removeClass('isOpen').find('ul').slideUp();
})

$('.menu-item-has-children > a').on('click', function(e){
	let $this = $(this);

	if( $win.width() < 1025 ){
		if( !$this.closest('li').hasClass('isOpen') ){
			e.preventDefault();

			$this.next().slideDown().closest('li').addClass('isOpen').siblings().removeClass('isOpen').find('ul').slideUp();
		}
	}
})
